import React from 'react';

const Header = ({ flowName, setFlowName, isActive, setIsActive, onSave }) => {
    return (
        <div className="wf-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                    type="text"
                    className="wf-input"
                    value={flowName}
                    onChange={(e) => setFlowName(e.target.value)}
                    style={{ width: '200px', marginBottom: 0 }}
                    placeholder="Flow Name"
                />
                <label className="wf-label" style={{ marginBottom: 0, display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                    <input
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                    Is Active
                </label>
            </div>

            <button className="wf-btn wf-btn-primary" onClick={onSave}>
                Save Flow
            </button>
        </div>
    );
};

export default Header;
